import { createI18n } from 'vue-i18n';

import en from '~/i18n/en.json';
import fr from '~/i18n/fr.json';

const i18n = createI18n({
	fallbackLocale: 'fr', // set fallback locale
	globalInjection: true,
	legacy: false, // use composition API
	locale: 'fr', // set locale
	messages: {
		en,
		fr
	}, 
	datetimeFormats: {
		fr: {
		  short: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' },
		  long: { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }
		},
		en: {
		  short: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' },
		  long: { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }
		}
	  }
});

export { i18n };
